module.exports = __webpack_public_path__ + "media/images/prizes/label_img-9e46440f4e69a43d5c6eca6acc84a8b2.png";